import api from "../config/configApi";

type EspecialidadePayload = {
  idProfissional?: number;
  id?: number;
  especialidade?: {
    dsEspecialidade?: string;
  } | string;
  dsEspecialidade?: string;
  categorias?: string;
  categoria?: string;
  cdEspecializacao?: number | string;
};

const sanitizarTexto = (valor: unknown) => {
  if (typeof valor !== "string") return "";
  return valor.replace(/\s+/g, " ").trim();
};

const extrairEspecialidadeDoItem = (item: EspecialidadePayload | undefined) => {
  if (!item) return "";

  const candidatos = [
    item.especialidade && typeof item.especialidade === "object"
      ? item.especialidade.dsEspecialidade
      : item.especialidade,
    item.dsEspecialidade,
    item.categorias,
    item.categoria,
  ];

  for (const candidato of candidatos) {
    const texto = sanitizarTexto(candidato);
    if (texto) return texto;
  }

  if (item.cdEspecializacao !== undefined && item.cdEspecializacao !== null) {
    const texto = sanitizarTexto(String(item.cdEspecializacao));
    if (texto) {
      return `Especialização ${texto}`;
    }
  }

  return "";
};

const normalizarRespostaProfissionais = (
  payload: unknown,
  idProfissional: number,
) => {
  if (Array.isArray(payload)) {
    const encontrado = payload.find((item: EspecialidadePayload) => {
      const id = Number(item?.idProfissional ?? item?.id);
      return id === idProfissional;
    });
    return extrairEspecialidadeDoItem(encontrado);
  }

  if (payload && typeof payload === "object") {
    return extrairEspecialidadeDoItem(payload as EspecialidadePayload);
  }

  return "";
};

export const buscarEspecialidadesProfissionais = async (
  profissionaisIds: number[],
  token?: string | null,
) => {
  if (!token || profissionaisIds.length === 0) return {};

  const especialidadesMap: Record<number, string> = {};

  await Promise.all(
    profissionaisIds.map(async (id) => {
      const endpoints = [`/sisclinic/profissionais/${id}`, `/profissionais/${id}`];

      for (const endpoint of endpoints) {
        try {
          const response = await api.get(endpoint, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const especialidade = normalizarRespostaProfissionais(response.data, id);

          especialidadesMap[id] = especialidade || "Sem Especialidade";
          return;
        } catch {
          continue;
        }
      }

      especialidadesMap[id] = "Sem Especialidade";
    }),
  );

  return especialidadesMap;
};

export const normalizarEspecialidadeTexto = (valor: unknown) =>
  sanitizarTexto(valor);
